import React from "react";
import { IconComponent } from "../../icon-component";
import icons from "../../icon-component/icon";
import styles from "./CustomChipsIcon.module.css";

const iconSizes = {
	sm: "xs",
	md: "sm",
};

// color: "info" | "success" | "warning" | "error" | "neutral"
// size:  "md" | "sm"

export default function CustomChipsIcon({ icon = null, onClick = null, color = "info", size = "md", className = "" }) {
	const resolvedIcon = icon || icons.faExclamation;
	const Tag = onClick ? "button" : "div";
	const extraProps = onClick ? { type: "button", onClick } : {};

	return (
		<Tag className={`${styles.chip} ${className}`} data-color={color} data-size={size} {...extraProps}>
			<IconComponent color="currentColor" icon={resolvedIcon} size={iconSizes[size]} />
		</Tag>
	);
}
